import { isMobile } from 'react-device-detect'
import {
	CONFIG_CONSTANTS,
	CART_CONSTANTS,
	PRODUCT_CONSTANTS,
	STORE_CONSTANTS,
} from '../actionTypes'
import { HELPER } from '../../utils'

const selected_category = {
	banner: '',
	description: '',
	id: '',
	is_default: '',
	name: '',
}

const selected_product = {
	id: '',
	selected_variant: { variant_id: '' },
}

const initState = {
	inventory_settings: {
		max_quantity: 0,
		maximum_purchase_limit: 0,
	},
	categories: [],
	products: [],
	allProducts: [],
	productsPerPage: isMobile
		? process.env.REACT_APP_PRODUCTS_PER_PAGE_MOBILE
		: process.env.REACT_APP_PRODUCTS_PER_PAGE_DESKTOP,
	productsCurrentPage: 1,
	visibleProducts: [],
	totalPages: 1,
	selected_category,
	selected_product,
	loadMore: false,
}
let response, catalog_settings

const inventoryReducer = (state = initState, action) => {
	switch (action.type) {
		case 'RESET':
			return initState
		case CONFIG_CONSTANTS.SET_APP_SETTINGS_TO_DEFAULT:
			return initState
		case STORE_CONSTANTS.ACCESS_NEW_STORE:
			return initState

		case CONFIG_CONSTANTS.CLEAR_SELECTED_CATEGORY:
			return {
				...state,
				selected_category: selected_category,
			}
		case CONFIG_CONSTANTS.STORE_CATALOG_INFO_SUCCESS:
			response = action?.response?.data
			catalog_settings = response?.catalog_settings
			let show_cart_item = !HELPER.isEmpty(response?.cart_items?.id)
				? response?.cart_items
				: state?.selected_product
			let show_selected_category = !HELPER.isEmpty(response?.cart_items?.id)
				? response?.categories_with_products?.default_category?.category
				: response?.categories_with_products?.default_category?.category
			// let show_selected_category = !HELPER.isEmpty(response?.cart_items?.id) ? response?.cart_items?.category : response?.categories_with_products?.default_category?.category
			return {
				...state,
				categories: response?.categories_with_products.categories_with_products,
				products: response?.categories_with_products?.default_category?.products,
				allProducts: response?.products,
				productsPerPage: isMobile
					? process.env.REACT_APP_PRODUCTS_PER_PAGE_MOBILE
					: process.env.REACT_APP_PRODUCTS_PER_PAGE_DESKTOP,
				inventory_settings: {
					max_quantity: catalog_settings?.max_quantity,
					maximum_purchase_limit: response?.metadata?.maximum_purchase_limit,
				},
				selected_category: show_selected_category,
				selected_product: show_cart_item,
			}
		case CONFIG_CONSTANTS.UPDATED_STORE_CONFIGURATION_SUCCESS:
			return {
				...state,
				productsPerPage: isMobile
					? process.env.REACT_APP_PRODUCTS_PER_PAGE_MOBILE
					: process.env.REACT_APP_PRODUCTS_PER_PAGE_DESKTOP,
			}
		case CART_CONSTANTS.CHANGE_CATEGORY_SUCCESS:
			response = action?.response
			return {
				...state,
				selected_category: action?.response?.category,
				products: response?.products,
				productsCurrentPage: 1,
				productsPerPage: isMobile
					? parseInt(process.env.REACT_APP_PRODUCTS_PER_PAGE_MOBILE)
					: parseInt(process.env.REACT_APP_PRODUCTS_PER_PAGE_DESKTOP),
			}
		case PRODUCT_CONSTANTS.SET_CATALOG_VISIBLE_PRODUCT_SUCCESS:
			response = action?.response
			return {
				...state,
				productsCurrentPage: response?.productsCurrentPage,
				visibleProducts: response?.concat
					? [...state.visibleProducts, ...response?.visible_products]
					: response?.visible_products,
				totalPages: response?.total_pages,
				loadMore: false,
			}
		case PRODUCT_CONSTANTS.LOAD_MORE_PRODUCTS:
			return {
				...state,
				loadMore: true,
			}
		case CART_CONSTANTS.SELECT_PRODUCT_VARIANT:
			return {
				...state,
				selected_product: { ...state?.selected_product, selected_variant: action?.variant },
			}
		case CART_CONSTANTS.SELECT_PRODUCT_ITEM:
			return {
				...state,
				selected_product: action?.product,
			}
		case CART_CONSTANTS.UN_SELECT_PRODUCT_ITEM:
			return {
				...state,
				selected_product:
					state?.selected_product?.id === action?.product?.id
						? selected_product
						: state?.selected_product,
			}
		case CART_CONSTANTS.REMOVE_ITEM_FROM_PRODUCT_ITEM:
			let product_item = action?.product_removed
			return {
				...state,
				selected_product:
					state?.selected_product?.id === product_item?.id
						? selected_product
						: state?.selected_product,
			}
		default:
			return state
	}
}
export default inventoryReducer
